/* global _p */

import React from "react";

// Decode HTML entities in a translated text segment.
function decodeHtmlEntities(text) {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = text;
  return textarea.value;
}

// Render a plain-text segment, turning <br> tags into actual line breaks.
function renderTextSegment(text, keyPrefix) {
  const parts = decodeHtmlEntities(text).split(/<br\s*\/?>/gi);
  return parts.map((part, index) => (
    <React.Fragment key={`${keyPrefix}-${index}`}>
      {part}{index < parts.length - 1 && <br/>}
    </React.Fragment>
  ));
}

/**
 * Format translated strings with line breaks and variable substitution.
 * The string is retrieved using the global _p function, like on EJS pages.
 * @note Variables in the translation string should be in the {variableName} format and passed as
 * an object. Values may be strings or React elements (e.g. an inline <a> link).
 * @param key // Translation key relative to the page.
 * @param variables
 * @returns {unknown[]|string}
 */
export function i18nFormat(key, variables = {}) {
  const translatedString = _p(key);
  if (!translatedString) return "";

  // Split the string into text segments and {variable} tokens, then map each to a node. This lets
  // React element values (such as inline links) be substituted in place of string-only replacement.
  const tokens = translatedString.split(/(\{[a-zA-Z0-9_]+\})/g);

  return tokens.map((token, index) => {
    const variableMatch = token.match(/^\{([a-zA-Z0-9_]+)\}$/);
    if (variableMatch && variableMatch[1] in variables) {
      return <React.Fragment key={index}>{variables[variableMatch[1]]}</React.Fragment>;
    }
    return <React.Fragment key={index}>{renderTextSegment(token, index)}</React.Fragment>;
  });
}
